/**
 * Centralized storage keys for localStorage and sessionStorage.
 * Using constants prevents typos and makes key usage searchable across the codebase.
 */

/** Session storage keys */
export const SESSION_STORAGE_KEYS = {
  ORG_ABBREVIATION: 'org-abbreviation',
  CLUB_ID: 'club-id',
  EVENT_VALIDATION_FLAGS: 'event-validation-flags',
  /** Show-admin dashboard stat tiles hidden via the eye toggle ('false'). */
  SHOW_ADMIN_STATS_VISIBLE: 'show-admin-stats-visible',
  /** Show-admin member total from the Members page, for the pre-show sidebar. */
  SHOW_ADMIN_MEMBER_COUNT: 'show-admin-member-count',
  /** Educator's `User/GetUserInfo` payload, fetched once after OTP login. */
  EDUCATOR_USER_INFO: 'educator-user-info',
} as const;

/** Local storage keys */
export const LOCAL_STORAGE_KEYS = {
  // Add local storage keys here as they are identified
} as const;

/** Type-safe storage key access */
export type SessionStorageKey = typeof SESSION_STORAGE_KEYS[keyof typeof SESSION_STORAGE_KEYS];
export type LocalStorageKey = typeof LOCAL_STORAGE_KEYS[keyof typeof LOCAL_STORAGE_KEYS];
